import clsx from 'clsx';
import React, { FC } from 'react';

type LogoProps = {
  size?: string;
  variant?: 'vertical' | 'horizontal';
  colorSchema?: [string, string, string];
  className?: string;
};

const Logo: FC<LogoProps> = (props) => {
  const {
    size = 'middle',
    variant = 'vertical',
    colorSchema = ['#fff', 'transparent', '#fff'],
    className,
  } = props;

  const sizes: Record<
    string,
    Record<string, { width: number; height: number; viewBox: string }>
  > = {
    vertical: {
      small: {
        width: 36,
        height: 36,
        viewBox: '0 0 510 510',
      },
      middle: {
        width: 70,
        height: 70,
        viewBox: '0 0 510 510',
      },
      large: {
        width: 140,
        height: 140,
        viewBox: '0 0 510 510',
      },
    },
    horizontal: {
      small: {
        width: 50,
        height: 25,
        viewBox: '0 0 510 410',
      },
      middle: {
        width: 100,
        height: 60,
        viewBox: '0 0 510 420',
      },
      large: {
        width: 200,
        height: 70,
        viewBox: '0 0 510 510',
      },
    },
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={sizes[variant][size].width}
      height={sizes[variant][size].height}
      viewBox={sizes[variant][size].viewBox}
      className={clsx(className)}
    >
      <rect fill={colorSchema[1]} width="1020.24" height="510.24" />
      <g>
        <g transform={variant === 'horizontal' ? 'translate(-160, 0)' : ''}>
          <g>
            <path
              fill={colorSchema[0]}
              d="M195.81,309.59v-68.65l-59.45-34.32l59.45-34.32v-68.65l59.45,34.32l59.45-34.32v68.65l59.45,34.32
          l-59.45,34.32v68.65l-59.45-34.32L195.81,309.59z M255.26,253.34l40.46,23.36v-46.72l40.46-23.36l-40.46-23.36v-46.72
          l-40.46,23.36l-40.46-23.36v46.72l-40.46,23.36l40.46,23.36v46.72L255.26,253.34z"
            />
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="308.69,122.9 255.26,92.05 201.83,122.9 196.62,103.97 255.26,70.12 314.3,104.21 				"
              />
            </g>
          </g>
          <g>
            <polygon
              fill={colorSchema[0]}
              className="st1"
              points="156.04,174.23 156.04,149.33 209.47,118.48 196.09,104.28 137.05,138.37 137.04,185.17 			"
            />
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="156.04,202.21 156.04,263.9 209.47,294.75 195.68,308.72 137.04,274.87 137.04,206.69 				"
              />
            </g>
          </g>
          <g>
            <polygon
              fill={colorSchema[0]}
              className="st1"
              points="276.82,308.74 255.26,321.19 201.83,290.34 196.21,309.03 255.26,343.12 295.79,319.72 			"
            />
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="308.69,122.9 255.26,92.05 201.83,122.9 196.62,103.97 255.26,70.12 314.3,104.21 				"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="156.04,202.21 156.04,263.9 209.47,294.75 195.68,308.72 137.04,274.87 137.04,206.69 				"
              />
            </g>
          </g>
          <g>
            <polygon
              fill={colorSchema[0]}
              className="st1"
              points="354.48,239 354.48,263.9 301.05,294.75 314.42,308.96 373.47,274.87 373.47,228.07 			"
            />
          </g>
          <g>
            <polygon
              fill={colorSchema[0]}
              className="st1"
              points="373.47,206.55 373.47,138.37 332.94,114.97 332.91,136.88 354.48,149.33 354.48,211.03 			"
            />
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="264.55,215.86 245.56,204.78 245.56,148.93 264.55,148.93 				"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="258.62,193.95 258.52,215.94 210.15,243.86 200.66,227.41 				"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                fill={colorSchema[0]}
                className="st1"
                points="242.6,210.04 261.7,199.13 310.06,227.06 300.57,243.51 				"
              />
            </g>
          </g>
        </g>
        {variant === 'vertical' && (
          <g>
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M132.63,411.34c0-4.13,3.36-7.58,7.49-7.58c1.54,0,2.88,0.38,4.03,1.15c4.42,2.78,9.5,4.61,15.55,4.61
        c5.66,0,9.12-2.4,9.12-5.47c0-3.65-4.13-5.09-10.94-6.53c-10.56-2.11-25.34-4.8-25.34-19.97c0-10.75,9.12-20.06,26.49-20.06
        c7.01,0,13.92,1.54,19.87,4.61c2.4,1.15,4.13,3.74,4.13,6.62c0,4.13-3.36,7.49-7.49,7.49c-1.25,0-2.5-0.38-3.55-0.86
        c-5.28-2.5-9.98-3.74-14.02-3.74c-6.43,0-8.54,2.21-8.54,4.99c0,3.36,3.94,4.51,11.04,5.86c10.56,2.21,25.15,5.28,25.15,19.77
        c0,12.86-9.5,21.41-26.69,21.41c-9.41,0-16.61-2.11-22.65-5.86C134.07,416.42,132.63,414.12,132.63,411.34z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M233.85,419.01l-24.57-35.23v31.2c0,4.51-3.65,8.35-8.26,8.35c-4.61,0-8.26-3.84-8.26-8.35v-46.56
        c0-5.86,4.8-10.85,10.85-10.85c3.65,0,6.82,1.82,8.83,4.7l23.23,33.02v-29.37c0-4.51,3.74-8.35,8.26-8.35
        c4.61,0,8.35,3.84,8.35,8.35v47.33c0,5.47-4.51,10.08-10.18,10.08C238.75,423.33,235.68,421.61,233.85,419.01z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M263.19,413.74v-46.56c0-5.66,3.07-8.74,8.74-8.74h32.06c3.74,0,6.91,3.17,6.91,7.01
        c0,3.74-3.17,6.91-6.91,6.91H279.7v10.66h23.61c3.74,0,6.91,3.17,6.91,7.01s-3.17,7.01-6.91,7.01H279.7v11.52h24.29
        c3.74,0,6.91,3.07,6.91,6.91s-3.17,7.01-6.91,7.01h-32.06C266.27,422.47,263.19,419.4,263.19,413.74z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M377.98,393.29v11.52c0,4.42-1.15,7.78-4.61,10.66c-6.24,5.09-14.11,8.16-23.71,8.16
        c-19.1,0-34.65-12.77-34.65-33.12s15.55-33.12,34.65-33.12c9.12,0,15.84,2.98,20.83,7.49c1.73,1.34,2.78,3.55,2.78,5.86
        c0,4.32-3.46,7.68-7.68,7.68c-2.02,0-3.94-0.77-5.28-2.02c-2.78-2.59-6.34-4.42-10.66-4.42c-10.46,0-17.85,8.06-17.85,18.53
        c0,10.46,7.39,18.53,17.85,18.53c5.57,0,9.6-1.82,11.81-3.84v-4.99h-8.35c-3.74,0-6.91-3.26-6.91-7.1c0-3.74,3.17-7.39,6.91-7.39
        h17.47C374.82,385.71,377.98,389.07,377.98,393.29z"
            />
          </g>
        )}
        {variant === 'horizontal' && (
          <g transform="translate(120, -170)">
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M132.63,411.34c0-4.13,3.36-7.58,7.49-7.58c1.54,0,2.88,0.38,4.03,1.15c4.42,2.78,9.5,4.61,15.55,4.61
        c5.66,0,9.12-2.4,9.12-5.47c0-3.65-4.13-5.09-10.94-6.53c-10.56-2.11-25.34-4.8-25.34-19.97c0-10.75,9.12-20.06,26.49-20.06
        c7.01,0,13.92,1.54,19.87,4.61c2.4,1.15,4.13,3.74,4.13,6.62c0,4.13-3.36,7.49-7.49,7.49c-1.25,0-2.5-0.38-3.55-0.86
        c-5.28-2.5-9.98-3.74-14.02-3.74c-6.43,0-8.54,2.21-8.54,4.99c0,3.36,3.94,4.51,11.04,5.86c10.56,2.21,25.15,5.28,25.15,19.77
        c0,12.86-9.5,21.41-26.69,21.41c-9.41,0-16.61-2.11-22.65-5.86C134.07,416.42,132.63,414.12,132.63,411.34z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M233.85,419.01l-24.57-35.23v31.2c0,4.51-3.65,8.35-8.26,8.35c-4.61,0-8.26-3.84-8.26-8.35v-46.56
        c0-5.86,4.8-10.85,10.85-10.85c3.65,0,6.82,1.82,8.83,4.7l23.23,33.02v-29.37c0-4.51,3.74-8.35,8.26-8.35
        c4.61,0,8.35,3.84,8.35,8.35v47.33c0,5.47-4.51,10.08-10.18,10.08C238.75,423.33,235.68,421.61,233.85,419.01z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M263.19,413.74v-46.56c0-5.66,3.07-8.74,8.74-8.74h32.06c3.74,0,6.91,3.17,6.91,7.01
        c0,3.74-3.17,6.91-6.91,6.91H279.7v10.66h23.61c3.74,0,6.91,3.17,6.91,7.01s-3.17,7.01-6.91,7.01H279.7v11.52h24.29
        c3.74,0,6.91,3.07,6.91,6.91s-3.17,7.01-6.91,7.01h-32.06C266.27,422.47,263.19,419.4,263.19,413.74z"
            />
            <path
              fill={colorSchema[0]}
              className="st1"
              d="M377.98,393.29v11.52c0,4.42-1.15,7.78-4.61,10.66c-6.24,5.09-14.11,8.16-23.71,8.16
        c-19.1,0-34.65-12.77-34.65-33.12s15.55-33.12,34.65-33.12c9.12,0,15.84,2.98,20.83,7.49c1.73,1.34,2.78,3.55,2.78,5.86
        c0,4.32-3.46,7.68-7.68,7.68c-2.02,0-3.94-0.77-5.28-2.02c-2.78-2.59-6.34-4.42-10.66-4.42c-10.46,0-17.85,8.06-17.85,18.53
        c0,10.46,7.39,18.53,17.85,18.53c5.57,0,9.6-1.82,11.81-3.84v-4.99h-8.35c-3.74,0-6.91-3.26-6.91-7.1c0-3.74,3.17-7.39,6.91-7.39
        h17.47C374.82,385.71,377.98,389.07,377.98,393.29z"
            />
          </g>
        )}
      </g>
    </svg>
  );
};

export default Logo;
